import * as React from 'react';
import { BrowserUtils } from '../../../utils/browser';

export enum TabType {
    Vin,
    Model,
    Infotainment,
    ProductionPeriod
}

interface WizardTabPaneProps {
    //children?: React.ReactElement<any>[];
    children?: any;
    name: TabType;
    title: string;
    selected?: boolean;
    animate?: boolean;
}

export class WizardTabPane extends React.Component<WizardTabPaneProps, {}> {
    private elementDiv: HTMLDivElement = null;
    constructor(props: WizardTabPaneProps) {
        super(props);
    }

    componentDidMount() {
        if (this.props.selected && this.elementDiv) {
            this.elementDiv.classList.add(...['active', 'in', 'show']);
        }
    }

    componentDidUpdate(previousProps: WizardTabPaneProps) {
        if (this.props.animate) {
            this.changeSelectedTabAnimation();
        } else {
            this.changeSelectedTab();
        }
    }

    private changeSelectedTab() {
        if (this.elementDiv) {
            if (this.props.selected) {
                this.elementDiv.classList.add(...['active', 'in', 'show']);
            } else {
                this.elementDiv.classList.remove(...['active', 'in', 'show']);
            }
        }
    }

    private changeSelectedTabAnimation() {
        if (this.props.selected) {
            setTimeout(() => { if (this.elementDiv) this.elementDiv.classList.add(...['active', 'in', 'show']) }, 150);
        } else {
            if (this.elementDiv) {
                this.elementDiv.classList.remove('in');
            }
            setTimeout(() => {
                if (this.elementDiv) {
                    this.elementDiv.classList.remove('active');
                    this.elementDiv.classList.remove('show');
                }
            }, 150);
        }
    }

    private getClassNames(): string {
        let classNames = ['tab-pane'];

        if (this.props.animate && !BrowserUtils.IsIE) {
            classNames = [...classNames, 'fade'];
        }

        return classNames.join(' ');
    }

    render() {
        return (
            <div ref={div => this.elementDiv = div} role="tabpanel" className={this.getClassNames()}>
                {this.props.children}
            </div>
        );
    }
}
